export default require('./en.json')
